import { render, staticRenderFns } from "./TimeSelect.vue?vue&type=template&id=b3a95232&scoped=true"
import script from "./TimeSelect.vue?vue&type=script&lang=js"
export * from "./TimeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a95232",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3a95232')) {
      api.createRecord('b3a95232', component.options)
    } else {
      api.reload('b3a95232', component.options)
    }
    module.hot.accept("./TimeSelect.vue?vue&type=template&id=b3a95232&scoped=true", function () {
      api.rerender('b3a95232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/TimeSelect.vue"
export default component.exports